import * as recallApi from '@otter-ai/recall-client';
import { useMutation } from '@tanstack/react-query';
import type { RequestConfirmationEmailType } from '@/shared/types/auth';

export function useRequestConfirmationEmailMutation({
  onSuccess,
  onError,
}: {
  onSuccess?: (res: RequestConfirmationEmailType) => void;
  onError?: (error: Error) => void;
} = {}) {
  return useMutation<
    RequestConfirmationEmailType,
    Error,
    { userid: string; query_params?: string }
  >({
    mutationFn: async ({ userid, query_params }) => {
      const query = { userid, query_params };
      const response = await recallApi.requestConfirmationEmail({
        query,
        throwOnError: true,
      });
      return response.data;
    },
    onSuccess,
    onError,
  });
}
